var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedicineHest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Component 39 \\u2013 204",
    viewBox: "0 0 18 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2926"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2927"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2672"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#444",
    "data-name": "Rectangle 1105",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    stroke: "none",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 13,
    x: 0.5,
    y: 0.5,
    rx: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#444",
    "data-name": "Group 2671"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 7h2v6H8z",
    "data-name": "Rectangle 1106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11V9h6v2z",
    "data-name": "Rectangle 1107"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#444",
    "data-name": "Rectangle 1108"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M7 0h4a2 2 0 012 2v2H5V2a2 2 0 012-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 .5h4A1.5 1.5 0 0112.5 2v1a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5V2A1.5 1.5 0 017 .5z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineHest);
export default __webpack_public_path__ + "static/media/medicine-сhest.91af64df.svg";
export { ForwardRef as ReactComponent };